import $ from 'jquery'
import { cca_config } from '../../CCA_ENV_CONF/env'

import EnteteBonEtFacture from '@/views/en-tete-bon-facture';
import Vue from 'vue';
import VueHtml2pdf from 'vue-html2pdf'
import excel from 'vue-excel-export'
 
Vue.use(excel)
Vue.use(VueHtml2pdf)

export const utilMixins = {
    components: {
        EnteteBonEtFacture,
    },

    data() {
        return {
            clinique_assets_path: cca_config.C_URL+cca_config.C_URL_ASSET,
            
            base_url_clinique: cca_config.C_CLINIQUE_FE_URL,
            base_url_caisse: cca_config.C_CAISSE_FE_URL,
            base_url_stock: cca_config.C_STOCK_FE_URL,
            base_url_rh: cca_config.C_RH_FE_URL,

            default_country_code: cca_config.COUNTRY_CODE,
            ville_le: cca_config.VILLE_LE,

            foot_1: "",
            foot_2: "",
            current_date: new Date(),
            is_printing: false,

            list_months: [
                { id: '', lib: "Choisir" }, 
                { id: 1, lib: "Janvier" }, { id: 2, lib: "Février" },
                { id: 3, lib: "Mars" }, { id: 4, lib: "Avril" },
                { id: 5, lib: "Mai" }, { id: 6, lib: "Juin" },
                { id: 7, lib: "Juillet" }, { id: 8, lib: "Août" },
                { id: 9, lib: "Septembre" }, { id: 10, lib: "Octobre" },
                { id: 11, lib: "Novembre" }, { id: 12, lib: "Décembre" },
            ],

            is_exporting: false,
            json_meta: [
                [
                    {
                        'key': 'charset',
                        'value': 'utf-8'
                    }
                ]
            ],
            currency_lang: cca_config.CURRENCY_LANG,
            has_two_currencies: cca_config.HAS_TWO_CURRENCIES,
            principal_currency: cca_config.PRINCIPAL_CURRENCY,
            secondary_currency: cca_config.SECONDARY_CURRENCY,
            currency_info: {
                principal_currency: 'F.CFA',
                secondary_currency: '',
                rate: ''
            },

            info_clinique: {
                'logo': '', 'type_centre': '', 'nom': '',
                'pays': '', 'ville': '', 'adresse': '', 'specialites': '',
                'code_autorisation': '', 'entete': ''
            },
            has_info: false,
        };
    },

    created() {
        document.title = cca_config.VUE_APP_NAME;
    },

    computed: {
        /**
         * Liste of months of the year [ From january to current month ]
         * @returns 
         */
        monthOfYear() {
            let index;
            let m = []
            for (index = 0; index <= this.current_date.getMonth() + 1; index++) {
                m[index] = this.list_months[index];
            }
            return m;
        },

        config_info_clinique() {
            return this.$store.getters["config_info_clinique"];
        },
    },

    mounted() {
        this.checkInfoClinique()
    },

    methods: {
        checkInfoClinique() {
            this.info_clinique = this.config_info_clinique
            if (
                (this.config_info_clinique.nom && this.config_info_clinique.nom != '') && 
                (this.config_info_clinique.logo && this.config_info_clinique.logo != '')
            ) {
                this.nom_clinique = this.config_info_clinique.nom
                this.logo_clinique = this.config_info_clinique.logo
                this.has_info = true
            }
        },

        formatDateToDateHour(given_date) {
            let only_date = "",
                only_hour = "";
            let date = new Date(given_date);
            let month = date.getMonth() + 1;
            month = month < 10 ? "0" + month : month;

            let d = date.getDate();
            d = d < 10 ? "0" + d : d;

            only_date = d + "/" + month + "/" + date.getFullYear();
            let c_hour = date.getHours();
            let c_minute = date.getMinutes();

            if (c_hour < 10) c_hour = "0" + c_hour;
            if (c_minute < 10) c_minute = "0" + c_minute;
            only_hour = c_hour + "h" + c_minute;

            return only_date + " à " + only_hour;
        },

        formatDateToDmY(given_date) {
            let only_date = "";
            let date = new Date(given_date);
            let month = date.getMonth() + 1;
            month = month < 10 ? "0" + month : month;

            let d = date.getDate();
            d = d < 10 ? "0" + d : d;

            only_date = d + "/" + month + "/" + date.getFullYear();

            return only_date;
        },

        setDates() {
            let today_date = new Date();
            let yesterday_date = new Date();
            yesterday_date.setDate(today_date.getDate() - 1);
            today_date = `${today_date.getFullYear()}-${today_date.getMonth() + 1}-${today_date.getDate()}`;
            yesterday_date = `${yesterday_date.getFullYear()}-${yesterday_date.getMonth()+1}-${yesterday_date.getDate()}`;
            return { today_date, yesterday_date };
        },

        /**
         * Format input to only digit
         * @param {*} selector
         */
        async onlyDigits(selector) {
            $("#" + selector).val(
                $("#" + selector)
                    .val()
                    .replace(/[^0-9]+/g, "")
            );
        },

        formatCurrency(num) {
            return new Number(num).toLocaleString("fr-FR");
        },

        capitalizeFirstLetter(value) {
            return value[0]
        },

        successToast: function (message) {
            this.$toasted.show(message, {
                duration: 3000,
                action: [
                    {
                        text: "X",
                        onClick: (e, toastObject) => {
                            toastObject.goAway(0);
                        },
                    },
                ],
                theme: "toasted-primary",
                type: "success",
                position: "top-center",
            });
        },

        errorToast: function (message) {
            this.$toasted.show(message, {
                duration: 3000,
                action: [
                    {
                        text: "X",
                        onClick: (e, toastObject) => {
                            toastObject.goAway(0);
                        },
                    },
                ],
                theme: "toasted-danger",
                type: "danger",
                position: "top-center",
            });
        },

        goTo(url) {
            this.$router.push({ path: url });
        },

        printPDF() {
            this.is_printing = true;

            this.$refs.html2Pdf.generatePdf();
        },

        async beforeDownload({ html2pdf, options, pdfContent }) {
            const newOptions = {
                ...options,
                pagebreak: {
                    mode: ['avoid-all']
                },
            }

            await html2pdf()
                .set(newOptions)
                .from(pdfContent)
                .set({
                    margin: [0.2, 0, 1, 0], 
                })
                .toPdf()
                .get("pdf")
                .then((pdf) => {
                    const totalPages = pdf.internal.getNumberOfPages();
                    this.getFooter();

                    const page_size = pdf.internal.pageSize.getWidth()
                    const page_height = pdf.internal.pageSize.getHeight()

                    for (let i = 1; i <= totalPages; i++) {
                        pdf.setPage(i);

                        pdf.setFontSize(10)
                        pdf.text(this.foot_1, (page_size / 2), (page_height - 0.5), {align: 'center'})
                        pdf.text(this.foot_2, (page_size / 2), (page_height - 0.3), {align: 'center'})

                        // pdf.setFontSize(10);
                        // pdf.text(
                        //     this.foot_1,
                        //     pdf.internal.pageSize.getWidth() * 0.18,
                        //     pdf.internal.pageSize.getHeight() - 0.8
                        // );
                        // pdf.text(
                        //     this.foot_2,
                        //     pdf.internal.pageSize.getWidth() * 0.32,
                        //     pdf.internal.pageSize.getHeight() - 0.6
                        // );

                        // pdf.text(
                        //     "Page " + i + " sur " + totalPages,
                        //     pdf.internal.pageSize.getWidth() * 0.88,
                        //     pdf.internal.pageSize.getHeight() - 0.3
                        // );
                    }
                })
                .save()
                .then(() => {
                    this.is_printing = false;
                });
        },

        getFooter() {
            // EPHATA
            this.foot_1 = cca_config.FOOT_1;
            this.foot_2 = cca_config.FOOT_2;
        },

        hasDownloaded() { },

        onProgress() { },

        startPagination() { },

        hasPaginated() { },

        /**
         * Excel Export 
         */
        handleBeforeFinish() {
            this.is_exporting = false
        },

        transformToNumber(value) {
            return +value;
        },

        /**
         * Validate a string not to be empty
         * @param {*} value 
         */
        validateStringNotEmpty(value) {
            if (typeof value  === 'string') {
                if (value.trim().length === 0) {
                    return true
                }
            }
            return false
        },

        cleanNumber(value) {
            if (this.validateStringNotEmpty(value)) {
                return ''
            }
            value = this.transformToNumber(value)
            if (!this.validateNumber(value)) {
                return ''
            }
            return value
        },

        validateNumber(number) {
            if (isNaN(number) || typeof number !== 'number') {
              return false
            }
            return true
        },

        toggleCollapse(selector) {
            const el = document.getElementById(selector)
            const hd = document.querySelectorAll(".section-box")
            
            if (hd != null) {
                for (let i = 0; i < hd.length; ++i) {
                    hd[i].classList.remove('show');
                }
            }
            
            el.classList.add('show')
        },
    },
};

// Export a separate token variable for global access
export let token = ""; 

// Function to update the token
export function setToken(newToken) {
    token = newToken;
}